import React from 'react';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import { useAuth } from '../../hooks/useAuth';
import { usePlayAction } from '../../hooks/usePlayAction';
import { RootState } from '../../store';

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  /** Current page key — that button is omitted from the nav to avoid a self-link */
  current?: 'dashboard' | 'profile' | 'shop' | 'zones' | 'admin';
}

export const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle, current }) => {
  const { t }   = useTranslation();
  const navigate = useNavigate();
  const { logout } = useAuth();
  const isAdmin = useSelector((s: RootState) => s.auth.isAdmin);
  const { play: handlePlay, loading: playLoading } = usePlayAction();

  const handleLogout = () => { logout(); navigate('/'); };

  return (
    <header className="dashboard__header">
      <div className="dashboard__header-left">
        <h1 className="dashboard__title">{title}</h1>
        {subtitle && <span className="dashboard__subtitle">{subtitle}</span>}
      </div>
      <div style={{ display: 'flex', gap: '0.75rem', alignItems: 'center', flexWrap: 'wrap' }}>
        <button className="dashboard__back-btn" onClick={() => navigate('/')}>
          {t('common.backToMap')}
        </button>
        <button className="dashboard__play-btn" onClick={handlePlay} disabled={playLoading}>
          {playLoading ? t('common.loading') : t('common.navPlay')}
        </button>
        {current !== 'dashboard' && (
          <button className="dashboard__back-btn" onClick={() => navigate('/dashboard')}>
            {t('common.navDashboard')}
          </button>
        )}
        {isAdmin && current !== 'admin' && (
          <button className="dashboard__back-btn" onClick={() => navigate('/admin')}>
            {t('common.navAdmin')}
          </button>
        )}
        <button className="dashboard__back-btn" onClick={handleLogout}>
          {t('common.navLogout')}
        </button>
      </div>
    </header>
  );
};
